import React, { useCallback } from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import Name from '@/components/Name'
import { DropDownList } from '@/components/dropDownList'
import { useLocalization } from '@/hooks/localization'
import { useDataLoader } from '@/hooks/useDataLoader'
import { isDefinedAndNotEmpty } from '@/utils/isDefined'

export class LookupCell extends GridCell {
  render () {
    let value = this.props.dataItem[this.props.field]
    return (<td><Name data={value} /></td>)
  }
}

export function createLookupFilterCell (dataSource, additionalProps = null) {
  return function LookupFilterCell (props) {
    return <PureLookupFilterCell {...props} dataSource={dataSource} {...additionalProps} />
  }
}

const PureLookupFilterCell = React.memo(function PureLookupFilterCell ({ dataSource, filter, filterData, transform, value, onChange }) {
  const { localizeProps } = useLocalization()
  const { data, loading } = useDataLoader(dataSource, filter, filterData, transform)
  const onValueChange = useCallback(({ value, item }) => {
    onChange({
      value: item || '',
      operator: item ? 'eq' : ''
    })
  }, [onChange])
  return (
    <div>
      <div className={'k-filtercell' + (isDefinedAndNotEmpty(value) ? ' k-filtercell-filtered' : '')}>
        <DropDownList
          data={data}
          textField={localizeProps()}
          valueField='id'
          onChange={onValueChange}
          value={value}
          loading={loading}
          allowClear
        />
      </div>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/lookupCell.js